import { i18n } from '@/i18n';
import { DialogListConfig, ModuleListConfig, ModuleName } from '@/types/module-type';
import TravelRecommend from '@/components/area/japan/travel-recommend.vue';
import HotMerchant from '@/components/hot-merchant.vue';
import AreaREcommend from '@/components/area-recommend.vue';

// 日本模块配置
export const JAPAN_MODULE_CONF: ModuleListConfig = [
  {
    moduleName: ModuleName.TravelRecommend,
    component: TravelRecommend,
    sort: 2,
    moduleTitle: i18n('出行推薦'),
    extraConfig: {
      modulePositionId: ['1100040000370011'],
    },
  },
  {
    moduleName: ModuleName.HotMerchant,
    component: HotMerchant,
    sort: 3,
    moduleTitle: i18n('推薦商戶'),
  },
  {
    moduleName: ModuleName.AreaREcommend,
    component: AreaREcommend,
    sort: 4,
    moduleTitle: i18n('探尋更多目的地'),
  },
];

// 日本弹窗配置
export const JAPAN_DIALOG_CONF: DialogListConfig = [];
